import { Check } from '@mui/icons-material'
import { Typography } from '@mui/material'

interface PasswordStrengthProps {
  password: string
}

const typography = {
  component: 'span',
  display: 'block',
}

const icon = {
  fontSize: 16,
  verticalAlign: 'text-top',
  mr: 0.5,
}

export function PasswordStrength({ password }: PasswordStrengthProps) {
  const hasEightCharacters = password.length >= 8
  const hasCapitalLetter = !!password.match(/[A-Z]/)
  const hasNumber = !!password.match(/[0-9]/)

  return (
    <>
      <Typography
        variant="body2"
        color={hasEightCharacters ? 'success' : 'gray'}
        {...typography}
      >
        <Check sx={icon} />
        Ao menos 8 caracteres
      </Typography>
      <Typography
        variant="body2"
        color={hasCapitalLetter ? 'success' : 'gray'}
        {...typography}
      >
        <Check sx={icon} />
        Ao menos uma letra maiúscula
      </Typography>
      <Typography
        variant="body2"
        color={hasNumber ? 'success' : 'gray'}
        {...typography}
      >
        <Check sx={icon} />
        Ao menos um número
      </Typography>
    </>
  )
}
